import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getServiceKeyApi,
  getServiceNonKeyApi,
} from "../../services/api/serviceApikey";

const initialState = {
  keyData: [],
  nonKeyData: [],
  total: 1,
  params: {},
  allData: [],
  keyDataCount: 0,
  nonKeyDataCount: 0,
  keyDataPerPage: 0,
  nonKeyDataPerPage: 0,
  nonKeyDataPageNumber: 0,
  keyDataPgeNumber: 0,
  isLoading: false,
  keyDataRange: null,
  nonKeyDataRange: null,
  isFetching: false,
  error: null,
  isError: false,
};

export const getServiceKey = createAsyncThunk(
  "/service/get/key",
  async (values, { rejectWithValue }) => {
    try {
      const data = await getServiceKeyApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getServiceNonKey = createAsyncThunk(
  "/service/get/nonKey",
  async (values, { rejectWithValue }) => {
    try {
      const data = await getServiceNonKeyApi(values);
      if (data?.serverResponse?.code !== 200) return rejectWithValue(data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const serviceSlice = createSlice({
  name: "services",
  initialState,
  reducers: {},
  extraReducers: {
    [getServiceKey.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getServiceKey.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      state.keyData = payload.result?.data;
      state.keyDataCount = payload.result?.dataCount;
      state.keyDataPerPage = payload.result?.dataPerPage;
      state.keyDataPgeNumber = payload.result?.pageNumber;
      state.keyDataRange = payload.result?.dataRange;
      return state;
    },
    [getServiceKey.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
    [getServiceNonKey.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      return state;
    },
    [getServiceNonKey.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = false;
      state.error = null;
      state.nonKeyData = payload.result?.data;
      state.nonKeyDataCount = payload.result?.dataCount;
      state.nonKeyDataPerPage = payload.result?.dataPerPage;
      state.nonKeyDataPageNumber = payload.result?.pageNumber;
      state.nonKeyDataRange = payload.result?.dataRange;
      return state;
    },
    [getServiceNonKey.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.error = payload;
      return state;
    },
  },
});

// this is for dispatch
// export const { clearOrders } = ordersSlice.actions;

// this is for configureStore
export default serviceSlice.reducer;
